import React, { Component } from 'react';
import { Avatar, Divider } from 'antd';
import { Layout, Form, Popover, Button, Image } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined, LogoutOutlined } from '@ant-design/icons';
import GeneralHelper from '../../helpers/general';
import '../../layouts/index.css';

const { Header } = Layout;

export class NavigationHeader extends Component {
	constructor(props) {
		super(props);
		this.socket = React.createRef();

		this.state = {
			windowWidth: window.innerWidth
		};

		this.handleResize = this.handleResize.bind(this);
	}

	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	handleResize() {
		this.setState({
			windowWidth: window.innerWidth
		});
	}

	handleLanguageMenuClick = () => {};
	handleSettingMenuClick = () => {};
	handleLogout = () => {};

	getUsernameAvatar = (username, size = 'large') => {
		return (
			<div>
				<Avatar
					style={{
						backgroundColor: '#96CE56',
						verticalAlign: 'middle'
					}}
					size={size}
				>
					{username ? username.charAt(0).toUpperCase() : ''}
				</Avatar>
				<span style={{ paddingLeft: 20 }}>{username}</span>
			</div>
		);
	};

	signout = () => {
		this.props.history.push('/logout');
	};

	content = () => {
		const bookingAdmin = JSON.parse(localStorage.getItem('cso_transport_booking_app'));
		const {
			booker: { email, type }
		} = bookingAdmin;
		const firstLetter = email.charAt(0);

		const { windowWidth } = this.state;

		return (
			<>
				<Form mode="inline" style={{ width: '200px' }}>
					<Form.Item style={{ margin: 'auto 0' }}>
						<Avatar style={{ color: '#FFFFFF', backgroundColor: '#236B8E', marginRight: 8 }}> {firstLetter.toUpperCase()}</Avatar>
						<span>{email}</span>
					</Form.Item>
				</Form>
				<Divider style={{ margin: '12px 0' }} />

				<div style={{ margin: '0 10px' }}>
					<a onClick={this.signout} style={{ display: 'flex', justifyContent: 'space-between' }}>
						<div>Sign Out</div>
						<div>
							<LogoutOutlined />
						</div>
					</a>
				</div>
			</>
		);
	};

	render() {
		const bookingAdmin = JSON.parse(localStorage.getItem('cso_transport_booking_app'));
		const {
			booker: { email }
		} = bookingAdmin;
		const firstLetter = email.charAt(0);
		const { collapsed, handleOnCollapse } = this.props;
		const { windowWidth } = this.state;

		return (
			<Header trigger={null} className="header" style={{ background: '#fff', padding: '0 20px', height: '64px' }}>
				<Form className="select-lab-form" name="basic" mode="inline" style={{ display: 'flex', justifyContent: 'space-between' }}>
					<span style={{ display: 'flex', alignItems: 'center' }}>
						<Image className="navigation-layout-header-left-logo" preview={false} src={`${GeneralHelper.getImageBasePath()}/images/HKUST-logo.png`} onClick={() => this.props.history.push('/')}/>
						<div className="navigation-layout-header-left-separator" />
						{windowWidth > 424 ? (
							<div>
								<h3
									style={
										windowWidth < 591 ? { margin: 0, padding: 0, color: '#003366', fontSize: '14px', lineHeight: 1 } : { margin: 0, padding: 0, color: '#003366', fontSize: 16, lineHeight: 1 }
									}
								>
									Campus Services Office
								</h3>
								<h3 style={windowWidth < 591 ? { margin: 0, padding: 0, color: '#003366', fontSize: '14px' } : { margin: 0, padding: 0, color: '#003366', fontSize: 16 }}>
									Official Transport Booking System
								</h3>
							</div>
						) : (
							<div>
								<h3 style={windowWidth < 591 ? { margin: 0, padding: 0, color: '#003366', fontSize: '14px' } : { margin: 0, padding: 0, color: '#003366', fontSize: '14px' }}>
									CSO Official Transport Booking System
								</h3>
							</div>
						)}
					</span>
					<Popover content={this.content()}>
						<Form.Item style={{ margin: 'auto 0' }}>
							<Avatar style={{ color: '#FFFFFF', backgroundColor: '#236B8E', marginRight: 8 }}> {firstLetter.toUpperCase()}</Avatar>
							{(windowWidth > 767 || windowWidth > 767) && <span className="header-email">{email}</span>}
						</Form.Item>
					</Popover>
				</Form>
			</Header>
		);
	}
}

export default NavigationHeader;
